<template>
  <div class="container">
    <h5>{{ t('captureIntervalFromSpaceRestriction') }}</h5>
    <p>
      {{ t('determineFastestCaptureInterval') }}
    </p>
    <hr />
    <div class="row">
      <div class="col-sm">
        <FixedUnitInput
          :input-label="t('imageSize')"
          v-model.number="imageSizeMB"
          :unit="t('mb')"
        />
        <FixedUnitInput
          :input-label="t('storageSpace')"
          v-model.number="storageSpace"
          :unit="t('gb')"
        />
        <FixedUnitInput
          :input-label="t('totalLapseTime')"
          v-model.number="lapseTime"
          :unit="t('days')"
        />
      </div>
      <div class="col-sm">
        <FixedUnitOutput
          :output-label="t('fastestInterval')"
          :number="fastestInterval"
          :unit="t('minutes')"
        />
      </div>
    </div>
  </div>
</template>

  
  <script>
  import { ref, computed, reactive  } from 'vue';
  import FixedUnitInput from '../inputs/FixedUnitInput.vue';
  import FixedUnitOutput from '../inputs/FixedUnitOutput.vue';
  import { defaultRound } from '../../utils/math';
  import { useI18n } from 'vue-i18n';
  
  export default {
    components: {
      FixedUnitInput,
      FixedUnitOutput,
    },
    setup() {
      const imageSizeMB = ref(1.8);
      const storageSpace = ref(32);
      const lapseTime = ref(124);

      const { t } = useI18n();

      // Create a reactive object with a function
      const translations = reactive({
        t: (key) => t(key)
      })
  
      const fastestInterval = computed(() => {
        const totalImages = storageSpace.value * 1000 / imageSizeMB.value;
        const lapseTimeMinutes = lapseTime.value * 1440;
        return defaultRound(lapseTimeMinutes / totalImages);
      });
  
      return {
        imageSizeMB,
        storageSpace,
        lapseTime,
        fastestInterval,
        t: translations.t,
      };
    },
  };
  </script>
  